import { SET_AUTH_TOKEN, SET_AUTH_USER, SET_REDIRECT_URL, LOGOUT, SET_IP_ADDRESS } from '@/utils/store/mutationTypes'
import { datadogRum } from '@datadog/browser-rum'

export default {
  /**
   * Set auth token
   *
   * @param state
   * @param token
   * @param expires
   */
  [SET_AUTH_TOKEN] (state, { token, expires }) {
    state.token = token
    state.tokenExpires = expires
  },

  /**
   * Sets a user
   *
   * @param state
   * @param user
   */
  [SET_AUTH_USER] (state, { user }) {
    state.loggedIn = !!user
    state.user = user

    if (user?.user?._id) {
      state.userId = user.user._id
    }
  },

  /**
   * Sets redirect url
   *
   * @param state
   * @param url
   */
  [SET_REDIRECT_URL] (state, { url }) {
    state.redirectUrl = url
  },

  /**
   * Logout
   *
   * @param commit
   * @returns {Promise<void>}
   */
  [LOGOUT] (state) {
    state.token = ''
    state.loggedIn = false
    state.tokenExpires = ''
    state.user = null
    state.userId = null

    datadogRum.clearUser()
  },
  [SET_IP_ADDRESS] (state, { ipAddress }) {
    state.ipAddress = ipAddress
  }
}
